import {containsBounds} from "@churchofjesuschrist/maps-google-math";

export default function AreaAssignController($scope, $state, $q, DataService, DataConst, OrgService, MapService, MapDrawService, NotificationService, TitleService, utils, google, MosFrameAnalyticsService) {
	"ngInject";
	const CHANGE_STEWARDSHIP_ADOBE_ANALYTICS_FORM_NAME = 'Maps - Change Stewardship Form';
	const vm = this;

	vm.$onInit = () => {
		vm.areaId = $state.params.areaId;
		vm.mode = "select";
		vm.loading = true;

		DataService.getArea(vm.areaId).then((area) => {
			TitleService.setTitleTranslate("pros-maps.area.assign.title", area);
			vm.area = area;
			vm.originalAssigned = utils.cloneArray(vm.area.assigned);
			vm.map = DataService.instantMap();
			vm.recenter();

			vm.searchTypes = DataConst.UNIT_ORG_TYPES;
			vm.overlays = [];
			const assigned = DataService.getAssignedOrgs(vm.area) || [];
			vm.assigned = assigned;
			vm.originalEcclUnitsWithOrphanCounts = OrgService.getCurrentEcclUnits(area.ecclUnitOrgNumberOrphan, assigned);
			let promises = vm.assigned.map(DataService.loadDetails);
			return $q.all(promises).then(() => (
				vm.refreshAssigned().then(() => {
					vm.loading = false;
					MosFrameAnalyticsService.formStart(CHANGE_STEWARDSHIP_ADOBE_ANALYTICS_FORM_NAME);
					if ($scope.$$destroyed) {
						vm.cleanup();
					}
				})
			));
		});

		DataService.setMapOpts({labelsClean: true, onLabelClick: vm.onLabelClick});
		DataService.getOrgsByTypes(["WARD"]).then((wards) => {
			vm.wards = wards;
			vm.refreshMode();
		});

		$scope.$watch(() => (vm.choice), vm.refreshMode);
		$scope.$on("$destroy", vm.cleanup);
	};

	vm.cleanup = () => {
		MapDrawService.removeOverlays(vm.overlays);
	};

	vm.recenter = () => {
		MapService.centerMap(vm.area, vm.map);
	};

	vm.fitMap = () => {
		if (vm.area.bounds || vm.assigned.length) {
			let bounds = new google.maps.LatLngBounds();

			if (vm.area.bounds) {
				bounds.union(vm.area.bounds);
			}
			vm.assigned.forEach((unit) => {
				bounds.union(unit.bounds);
			});

			if (!containsBounds(vm.map.getBounds(), bounds)) {
				vm.map.fitBounds(bounds);
			}
		}
	};

	vm.addUnit = (unit) => {
		vm.assigned.push(unit);
		vm.refreshAssigned();
	};

	vm.removeUnit = (unit) => {
		utils.removeItem(unit, vm.assigned);
		vm.refreshAssigned();
	};

	vm.toggleUnit = (unit) => {
		if (utils.containsOrg(vm.assigned, unit)) {
			vm.removeUnit(unit);
		} else {
			vm.addUnit(unit);
		}
	};

	vm.onLabelClick = (org) => {
		if (vm.mode === "select" && utils.isUnit(org)) {
			vm.toggleUnit(org);
			return false;
		}
	};

	vm.refreshAssigned = () => {
		if (vm.assigned) {
			vm.assigned = utils.uniqueOrgs(vm.assigned).sort(utils.sortOrgs);
			vm.groups = MapService.updateTypeGroups(vm.assigned, vm.groups);

			let promises = vm.assigned.map(DataService.loadBoundary);
			return $q.all(promises).then(() => {
				if (!$scope.$$destroyed) {
					vm.fitMap();

					DataService.updateMapOpts({staticOrgs: vm.assigned});
				}
			});
		}
	};

	vm.refreshMode = () => {
		DataService.updateMapOpts({automaticOrgs: vm.mode === "select" ? vm.wards : null});
		switch (vm.mode) {
			case "select":
				vm.nonreduce = [];
				vm.refreshAssigned();
				break;
			case "relation":
				let relationAssigned = utils.toArray(vm.metadata[vm.choice]),
					relationAutomatic = vm.choice === "current" ? vm.metadata.all : null;
				DataService.updateMapOpts({staticOrgs: relationAssigned, automaticOrgs: relationAutomatic});
				vm.groups = MapService.groupByType(relationAssigned);
				break;
			case "reduce":
				let reduceAssigned = utils.toArray(vm.metadata[vm.choice]),
					reduceAutomatic = vm.choice === "parent" ? vm.metadata.children : [vm.metadata.parent];
				DataService.updateMapOpts({staticOrgs: reduceAssigned, automaticOrgs: reduceAutomatic});
				vm.groups = MapService.groupByType(reduceAssigned);
				break;
			case "done":
				vm.refreshAssigned();
				break;
		}
	};

	vm.generateArea = () => {
		let assigned = vm.assigned.map((unit) => (unit.id));
		return angular.extend({}, vm.area, {assigned});
	};

	vm.updateRelatedAreas = () => {
		let newArea = vm.generateArea(),
			oldArea = angular.extend({}, vm.area, {assigned: vm.originalAssigned});
		return DataService.getOverlappingAreas(newArea).then((newOverlappingAreas) => (
			DataService.getOverlappingAreas(oldArea).then((oldOverlappingAreas) => {
				let allOverlappingAreas = utils.uniqueOrgs(newOverlappingAreas.concat(oldOverlappingAreas));
				if (allOverlappingAreas.length) {
					let areaIds = allOverlappingAreas.map((area) => (area.id)),
						missionId = $state.params.missionId;
					return OrgService.getMissionAreas(missionId, areaIds).then((areas) => (
						$q.all(areas.map(DataService.updateArea))
					));
				}
			})
		));
	};

	vm.validateUnits = () => {
		let assignedParentUnits = vm.assigned.filter((unit) => (DataConst.PARENT_UNIT_ORG_TYPES.indexOf(unit.type) !== -1)),
			assignedChildUnits = vm.assigned.filter((unit) => (DataConst.CHILD_UNIT_ORG_TYPES.indexOf(unit.type) !== -1)),
			unitIds = [];
		assignedParentUnits.forEach((unit) => {
			if (unit.assigned) {
				unitIds.concat(...unit.assigned);
			}
		});
		return DataService.loadUnitDetails(unitIds).then(() => {
			let results = null,
				promises = [];

			// if child and it's parent of same sublayer are assigned
			assignedParentUnits.forEach((parent) => {
				if (!results) {
					let childUnits = DataService.getChildLayerUnits(parent),
						duplicateChildUnits = childUnits.filter((unit) => (utils.containsOrg(assignedChildUnits, unit)));
					if (duplicateChildUnits.length) {
						results = {
							mode: "relation",
							choice: "parent",
							metadata: {parent, current: duplicateChildUnits, all: childUnits}
						};
						promises.push(childUnits.map(DataService.loadBoundary));
					}
				}
			});

			//if assignedChildren includes all children of same sublayer as a nonassigned parent
			if (!results) {
				promises.push(DataService.getOrgsByTypes(DataConst.PARENT_UNIT_ORG_TYPES).then((allStakes) => {
					let parents = allStakes.filter((stake) => {
						let isParent = false;
						if (stake.assigned) {
							stake.assigned.forEach((unitId) => {
								if (!isParent && assignedChildUnits.filter((unit) => (unit.id === unitId)).length) {
									isParent = true;
								}
							});
						}
						return isParent;
					});

					parents.forEach((parent) => {
						if (!results && !utils.containsOrg(vm.nonreduce, parent)) {
							let childUnits = DataService.getChildLayerUnits(parent),
								children = childUnits.filter((unit) => (utils.containsOrg(assignedChildUnits, unit)));
							if (children.length === childUnits.length) {
								results = {
									mode: "reduce",
									choice: "parent",
									metadata: {parent, children}
								};
							}
						}
					});

					if (results) {
						return DataService.loadBoundary(results.metadata.parent);
					}
				}));
			}

			return $q.all(promises).then(() => (
				results || {mode: "done"}
			));
		});
	};


	vm.back = () => {
		vm.mode = "select";
		vm.refreshMode();
		vm.fitMap();
	};

	vm.next = () => {
		switch (vm.mode) {
			case "relation":
				for (let key in vm.metadata) {
					let units = utils.toArray(vm.metadata[key]);
					if (vm.choice === key) {
						vm.assigned.push(...units);
					} else {
						units.forEach((unit) => {
							utils.removeItem(unit, vm.assigned);
						});
					}
				}
				break;
			case "reduce":
				if (vm.choice === "parent") {
					vm.metadata.children.forEach((unit) => {
						utils.removeItem(unit, vm.assigned);
					});
					vm.assigned.push(vm.metadata.parent);
				} else {
					vm.nonreduce.push(vm.metadata.parent);
				}
				break;
		}
		vm.done();
	};

	vm.done = () => {
		vm.loading = true;
		vm.mode = null;
		DataService.updateMapOpts({staticOrgs: null, automaticOrgs: null});
		vm.validateUnits().then((results) => {
			vm.mode = results.mode;
			vm.choice = results.choice;
			vm.metadata = results.metadata;

			vm.refreshMode();
			vm.fitMap();
			vm.loading = false;
		});
		let ecclUnitsDeleted = OrgService.getEcclUnitsDeleted(vm.originalAssigned, vm.assigned);
		vm.ecclUnitsDeletedOrphanInfo = OrgService.getEcclUnitsDeletedOrphanInfo(ecclUnitsDeleted, vm.originalEcclUnitsWithOrphanCounts);
	};

	vm.save = () => {
		vm.loading = true;

		let area = vm.generateArea();

		OrgService.updateArea(area).then((area) => (
			DataService.updateArea(area).then(() => {
				vm.area = angular.extend({}, area);
				return vm.updateRelatedAreas().then(() => {
					NotificationService.success("pros-maps.success.saved.area", null, area);
					MosFrameAnalyticsService.formSubmit(CHANGE_STEWARDSHIP_ADOBE_ANALYTICS_FORM_NAME);
					vm.exit();
				});
			})
		), () => {
			NotificationService.exception(vm);
			MosFrameAnalyticsService.formError(CHANGE_STEWARDSHIP_ADOBE_ANALYTICS_FORM_NAME, ['server-error']);
		});
	};

	vm.exit = () => {
		$state.go("area", {areaId: vm.areaId});
	};

}
